export const PROMPT_P09_STEP1 = () => `
Analyze for SURFACE CARBONATION (EN 1504-9).
NOTE: Carbonation depth NOT visually detectable. Partial diagnosis — pH/phenolphthalein input required.
Visual (indirect): chalky white matte surface, fine crazing, rust staining consistent with rebar depassivation,
context: structure >20 years, urban high-CO2 environment, uncoated concrete.
Return ONLY this JSON:
{
  "pathology_id": "p09_carbonation",
  "pathology_name": { "es": "Carbonatación superficial", "en": "Surface carbonation" },
  "norm": "EN 1504-9",
  "confidence": 38,
  "requires_additional_input": true,
  "visual_indicators": "none|indirect_only|rust_staining|surface_crazing",
  "risk_factors_visible": { "es": "...", "en": "..." },
  "severity": "pending_ph_test",
  "urgency": "pending_ph_test",
  "additional_input": {
    "method": "phenolphthalein_or_ph",
    "instructions": {
      "es": "Rompe muestra fresca y aplica fenolftaleína al 1%. Zona incolora = carbonatada. Mide profundidad en mm.",
      "en": "Break a fresh sample and apply 1% phenolphthalein. Colorless zone = carbonated. Measure depth in mm."
    }
  },
  "disclaimer": { "es": "Carbonatación no detectable sin prueba de pH o fenolftaleína.", "en": "Carbonation not detectable without pH or phenolphthalein test." }
}`;

export const PROMPT_P09_STEP2 = (phResult = '', sponsorProduct = 'Sikagard-680 S BetoShield + MonoTop-910 S') => `
Complete CARBONATION diagnosis (EN 1504-9).
Test result from inspector: "${phResult}"
Return ONLY this JSON:
{
  "pathology_id": "p09_carbonation",
  "pathology_name": { "es": "Carbonatación superficial", "en": "Surface carbonation" },
  "norm": "EN 1504-9",
  "confidence": 88,
  "requires_additional_input": false,
  "carbonation_depth_mm": "0-5|5-15|15-30|>30|unknown",
  "rebar_at_risk": false,
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Si carbonatación no llegó a armadura: revestimiento anticarbonación EN 1504-2","2. Si llegó a armadura: demolición + pasivación + reparación EN 1504-3/7","3. Revestimiento con SD CO2 ≥50m (EN 1062-6)","4. Monitoreo con fenolftaleína cada 3–5 años"],
      "en": ["1. If not reached rebar: anti-carbonation coating EN 1504-2","2. If reached rebar: break-out + passivation + repair EN 1504-3/7","3. Coating with CO2 SD ≥50m (EN 1062-6)","4. Monitor with phenolphthalein every 3–5 years"]
    },
    "norm_reference": "EN 1504-9:2008; EN 1504-2; EN 1504-3"
  },
  "materials": {
    "generic": { "es": "Revestimiento anticarbonación acrílico SD CO2 ≥50m", "en": "Acrylic anti-carbonation coating CO2 SD ≥50m" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "BetoShield: SD CO2 >200m, cumple EN 1504-2 principio 1", "en": "BetoShield: CO2 SD >200m, complies EN 1504-2 principle 1" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "La profundidad medida es un punto en el tiempo. Monitoreo periódico obligatorio.", "en": "Measured depth is point-in-time. Periodic monitoring mandatory." }
}`;
